import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
  lang: 'en',
  theme: 'light',
  properties: [
    { BuildingId: '101', Name: 'Lincoln Yard' },
    { BuildingId: '102', Name: '333 North Green' },
  ],
}

let settingSlice = createSlice({
  name: 'setting',
  initialState: INITIAL_STATE,
  reducers: {
    changeTheme: function (state, action) {
      state.theme = action.payload
    },
    changeLang: function (state, action) {
      state.lang = action.payload
    },
    resetReducer: function (state) {
      state = INITIAL_STATE
    },
  },
})

const { reducer: settingReducer } = settingSlice

export const { changeTheme, changeLang, resetReducer } = settingSlice.actions
export default settingSlice.reducer

export { settingReducer }
